import { EXCHANGE_EVENT_TYPES } from "@hypexone/uicore";
import EventsAccordion from "./EventsAccordion";

const Sidebar = () => {
  return (
    <div className="min-w-28">
      {EXCHANGE_EVENT_TYPES.map(({ id, name }) => {
        return <EventsAccordion key={name} sportId={id} title={name} />;
      })}
    </div>
  );
};

export default Sidebar;
